import React from 'react';
import { DebugPanelProvider } from '@rsos/debug-panel';
import { useBooleanFlagValue } from '@rsos/utils/openFeature';
import panels from './panels';

export const DebugPanelGate: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  // Flag delivery is vendor-agnostic via OpenFeature (Datadog provider today).
  const isEnabled = useBooleanFlagValue('debug-panel', false);
  return (
    <DebugPanelProvider panels={isEnabled ? panels : []}>
      {children}
    </DebugPanelProvider>
  );
};
